<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { TONE_CLASSES } from './liveMetrics';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: [Number, String],
    default: 0,
  },
  icon: {
    type: String,
    required: true,
  },
  hint: {
    type: String,
    default: '',
  },
  tone: {
    type: String,
    default: 'slate',
    validator: value =>
      ['blue', 'amber', 'ruby', 'teal', 'slate'].includes(value),
  },
});

defineEmits(['select']);

const toneClass = computed(() => TONE_CLASSES[props.tone]);
</script>

<template>
  <button
    v-tooltip="$t('OVERVIEW_REPORTS.DETAIL.VIEW')"
    type="button"
    class="group flex min-w-0 flex-col gap-3 rounded-xl bg-n-solid-1 p-4 text-left outline outline-1 outline-n-container transition-colors hover:bg-n-alpha-1 hover:outline-n-strong rtl:text-right"
    @click="$emit('select')"
  >
    <div class="flex w-full items-center justify-between">
      <span
        class="flex size-8 items-center justify-center rounded-lg"
        :class="toneClass"
      >
        <Icon :icon="icon" class="size-4" />
      </span>
      <Icon
        icon="i-lucide-arrow-up-right"
        class="size-4 text-n-slate-10 opacity-0 transition-opacity group-hover:opacity-100"
      />
    </div>
    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-sm leading-tight text-n-slate-11">{{ label }}</span>
      <span class="text-3xl font-medium tabular-nums text-n-slate-12">
        {{ value }}
      </span>
      <span v-if="hint" class="text-xs leading-tight text-n-slate-10">
        {{ hint }}
      </span>
    </div>
  </button>
</template>
